import { Boundaries } from "@planzone/core";
import { Identifiable, Resource } from "@planzone/dto";

function handleAssignTagRequest(
  resource: Identifiable<Resource>,
  { assignableId, tag }: Boundaries["assignTag"]["request"],
): Identifiable<Resource> {
  return resource.uuid === assignableId
    ? {
        ...resource,
        tags: resource.tags ? [...resource.tags, tag] : [tag],
      }
    : resource;
}

function handleAssignTagSuccess(
  resource: Identifiable<Resource>,
  { assignableId, tag }: Boundaries["assignTag"]["success"],
): Identifiable<Resource> {
  if (resource.uuid !== assignableId) return resource;

  const index = resource.tags.findIndex(({ name }) => name === tag.name);

  return {
    ...resource,
    tags:
      index !== -1
        ? [
            ...resource.tags.slice(0, index),
            tag,
            ...resource.tags.slice(index + 1),
          ]
        : [...resource.tags, tag],
  };
}

function handleAssignTagFailure(
  resource: Identifiable<Resource>,
  { assignableId, tag }: Boundaries["assignTag"]["failure"],
): Identifiable<Resource> {
  return resource.uuid === assignableId
    ? {
        ...resource,
        tags: resource.tags.filter(({ name }) => name !== tag.name),
      }
    : resource;
}

export {
  handleAssignTagRequest,
  handleAssignTagSuccess,
  handleAssignTagFailure,
};
